import { useState } from 'react';
import { moreUpdates, todayUpdates } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function LatestUpdates() {
  const [expanded, setExpanded] = useState(false);
  const items = expanded ? [...todayUpdates, ...moreUpdates] : todayUpdates;

  return (
    <section id="updates" className="bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <SectionHeading
          index="01"
          eyebrow="Update Feed"
          title="今日更新条"
          desc="按发生时间从近到远排，每一条都标好它落在时间线的哪个位置，方便你接上之前看到的地方。"
        />

        <div className="border-t border-background-200">
          {items.map((item) => (
            <article
              key={item.id}
              className="grid grid-cols-1 items-start gap-3 border-b border-background-200 py-7 md:grid-cols-[120px_1fr_auto] md:gap-6 md:py-8"
            >
              <div className="font-label text-xs text-foreground-500 md:pt-1 md:text-sm">{item.time}</div>

              <div>
                <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 font-label text-[11px] text-secondary-900">
                  <i className="ri-price-tag-3-line text-xs" />
                  {item.tag}
                </span>
                <h3 className="mt-3 font-heading text-lg leading-snug text-foreground-950 md:text-xl">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>

              <a
                href="#timeline"
                aria-label="在时间线中查看"
                className="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-background-300 text-foreground-500 transition-colors hover:border-primary-300 hover:text-primary-600 md:flex"
              >
                <i className="ri-arrow-right-up-line text-lg" />
              </a>
            </article>
          ))}
        </div>

        {!expanded ? (
          <div className="mt-10 flex justify-center">
            <button
              type="button"
              onClick={() => setExpanded(true)}
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 px-6 py-3 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-add-line text-base" />
              加载更早的更新
            </button>
          </div>
        ) : null}
      </div>
    </section>
  );
}